import {
  createVariant as publicCreateVariant,
  getVariant as publicGetVariant,
  listVariants as publicListVariants,
  updateVariant as publicUpdateVariant,
  bulkCreateVariants as publicBulkCreateVariants,
  bulkUpdateVariants as publicBulkUpdateVariants,
  deleteVariant as publicDeleteVariant,
  queryVariants as publicQueryVariants,
  typedQueryVariants as publicTypedQueryVariants,
  countVariants as publicCountVariants,
  bulkDeleteVariants as publicBulkDeleteVariants,
} from './restaurants-menus-v1-item-variant-item-variants.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  VariantQuery,
  VariantsQueryBuilder,
  typedQueryVariants as universalTypedQueryVariants,
} from './restaurants-menus-v1-item-variant-item-variants.universal.js';
import { onItemVariantCreated as publicOnItemVariantCreated } from './restaurants-menus-v1-item-variant-item-variants.public.js';
import { onItemVariantDeleted as publicOnItemVariantDeleted } from './restaurants-menus-v1-item-variant-item-variants.public.js';
import { onItemVariantUpdated as publicOnItemVariantUpdated } from './restaurants-menus-v1-item-variant-item-variants.public.js';

function customQueryVariants(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryVariants(httpClient)(),
    typedQueryFunction: (query: VariantQuery) =>
      publicTypedQueryVariants(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): VariantsQueryBuilder;
  function overloadedQuery(
    query: VariantQuery
  ): ReturnType<typeof universalTypedQueryVariants>;
  function overloadedQuery(query?: VariantQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const createVariant: MaybeContext<
  BuildRESTFunction<typeof publicCreateVariant> & typeof publicCreateVariant
> = /*#__PURE__*/ createRESTModule(publicCreateVariant);
export const getVariant: MaybeContext<
  BuildRESTFunction<typeof publicGetVariant> & typeof publicGetVariant
> = /*#__PURE__*/ createRESTModule(publicGetVariant);
export const listVariants: MaybeContext<
  BuildRESTFunction<typeof publicListVariants> & typeof publicListVariants
> = /*#__PURE__*/ createRESTModule(publicListVariants);
export const updateVariant: MaybeContext<
  BuildRESTFunction<typeof publicUpdateVariant> & typeof publicUpdateVariant
> = /*#__PURE__*/ createRESTModule(publicUpdateVariant);
export const bulkCreateVariants: MaybeContext<
  BuildRESTFunction<typeof publicBulkCreateVariants> &
    typeof publicBulkCreateVariants
> = /*#__PURE__*/ createRESTModule(publicBulkCreateVariants);
export const bulkUpdateVariants: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateVariants> &
    typeof publicBulkUpdateVariants
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateVariants);
export const deleteVariant: MaybeContext<
  BuildRESTFunction<typeof publicDeleteVariant> & typeof publicDeleteVariant
> = /*#__PURE__*/ createRESTModule(publicDeleteVariant);
export const countVariants: MaybeContext<
  BuildRESTFunction<typeof publicCountVariants> & typeof publicCountVariants
> = /*#__PURE__*/ createRESTModule(publicCountVariants);
export const bulkDeleteVariants: MaybeContext<
  BuildRESTFunction<typeof publicBulkDeleteVariants> &
    typeof publicBulkDeleteVariants
> = /*#__PURE__*/ createRESTModule(publicBulkDeleteVariants);
export const queryVariants: MaybeContext<
  BuildRESTFunction<typeof customQueryVariants> & typeof customQueryVariants
> = /*#__PURE__*/ createRESTModule(customQueryVariants);
/** */
export const onItemVariantCreated: BuildEventDefinition<
  typeof publicOnItemVariantCreated
> &
  typeof publicOnItemVariantCreated = createEventModule(
  publicOnItemVariantCreated
);
/** */
export const onItemVariantDeleted: BuildEventDefinition<
  typeof publicOnItemVariantDeleted
> &
  typeof publicOnItemVariantDeleted = createEventModule(
  publicOnItemVariantDeleted
);
/** */
export const onItemVariantUpdated: BuildEventDefinition<
  typeof publicOnItemVariantUpdated
> &
  typeof publicOnItemVariantUpdated = createEventModule(
  publicOnItemVariantUpdated
);

export {
  SortOrder,
  WebhookIdentityType,
} from './restaurants-menus-v1-item-variant-item-variants.universal.js';
export {
  Variant,
  ExtendedFields,
  ExternalReferenceInfo,
  InvalidateCache,
  InvalidateCacheGetByOneOf,
  App,
  Page,
  URI,
  File,
  CustomTag,
  Pages,
  URIs,
  CreateVariantRequest,
  CreateVariantResponse,
  GetVariantRequest,
  GetVariantResponse,
  ListVariantsRequest,
  CursorPaging,
  ListVariantsResponse,
  CursorPagingMetadata,
  Cursors,
  UpdateVariantRequest,
  UpdateVariantResponse,
  BulkCreateVariantsRequest,
  BulkCreateVariantsResponse,
  BulkVariantResult,
  ItemMetadata,
  ApplicationError,
  BulkActionMetadata,
  BulkUpdateVariantsRequest,
  MaskedVariant,
  BulkUpdateVariantsResponse,
  DeleteVariantRequest,
  DeleteVariantResponse,
  QueryVariantsRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  QueryVariantsResponse,
  CountVariantsRequest,
  CountVariantsResponse,
  CloneVariantsRequest,
  CloneVariantsResponse,
  BulkDeleteVariantsRequest,
  BulkDeleteVariantsResponse,
  BulkDeleteVariantsResult,
  BulkUpdateBusinessLocationIdsRequest,
  BulkUpdateBusinessLocationIdsResponse,
  BulkUpdateBusinessLocationIdsResponseBulkItemResult,
  BulkUpdateBusinessLocationIdsPerEntityRequest,
  VariantIdLocationIds,
  BulkUpdateBusinessLocationIdsPerEntityResponse,
  BulkUpdateBusinessLocationIdsPerEntityResponseBulkItemResult,
  BulkUpdateAttachedToOrphanItemRequest,
  VariantIdAttachedToOrphanItem,
  BulkUpdateAttachedToOrphanItemResponse,
  BulkItemResult,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  SyncContentToMultilingualRequest,
  SyncContentToMultilingualResponse,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  ItemVariantCreatedEnvelope,
  ItemVariantDeletedEnvelope,
  ItemVariantUpdatedEnvelope,
  ListVariantsOptions,
  UpdateVariant,
  BulkCreateVariantsOptions,
  BulkUpdateVariantsOptions,
  VariantsQueryResult,
  VariantsQueryBuilder,
  VariantQuerySpec,
  CountVariantsOptions,
} from './restaurants-menus-v1-item-variant-item-variants.universal.js';
export { utils } from './restaurants-menus-v1-item-variant-item-variants.universal.js';
export {
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CountVariantsApplicationErrors,
  CommonQueryWithEntityContext,
  VariantQuery,
} from './restaurants-menus-v1-item-variant-item-variants.universal.js';
